<main class="container-fluid">
    <section class="row bg-white shadow mb-3 mt-3 ml-0 mr-0">
        <div class="col-3 border-right p-4 mt-5 mb-5">
            <header class="text-center mb-3">
                Editar
            </header>

            <form [formGroup]="formEdicion" (ngSubmit)="guardar()">

                <label class="small text-secondary font-weight-bold mt-2" for="departamentoCtrl">
                    Cámara de Comercio
                </label>
                <select id="camaraComercioCtrl" class="form-control form-control-sm"
                    formControlName="camaraComercioCtrl">
                    <option value=""></option>
                    <option value="{{item.codigo_camara}}" *ngFor="let item of camarasComercio">{{item.desc_camara}}
                    </option>
                </select>

                <label class="small text-secondary font-weight-bold mt-2" for="departamentoCtrl">Departamento</label>
                <select id="departamentoCtrl" class="form-control form-control-sm" formControlName="departamentoCtrl">
                    <option value=""></option>
                    <option value="{{item.departamento_id}}" *ngFor="let item of departamentos">{{item.descripcion}}
                    </option>
                </select>

                <label class="small text-secondary font-weight-bold mt-2" for="municipioCtrl">Municipio*</label>
                <select id="municipioCtrl" class="form-control form-control-sm" formControlName="municipioCtrl">
                    <option value=""></option>
                    <option value="{{item.municipio_id}}" *ngFor="let item of municipios">{{item.descripcion}}
                    </option>
                </select>

                <label class="small text-secondary font-weight-bold mt-2" for="municipioCtrl">Tipo Solicitud*</label>
                <select id="tipoSolicitudCtrl" class="form-control form-control-sm" formControlName="tipoSolicitudCtrl">
                    <option value=""></option>
                    <option value="{{item.tipo_solicitud_id}}" *ngFor="let item of tipoSolicitudes">{{item.descripcion}}
                    </option>
                </select>


                <label class="small text-secondary" for="nit">Categoría</label>
                <select class="form-control form-control-sm" id="fcategoriaCtrl" formControlName="fcategoriaCtrl">
                  <option class="" [ngValue]="null" selected="true">
                    Seleccione
                  </option>
                  <option class="" *ngFor="let option of categoria; let i = index"
                    value="{{option?.categoria_id}}" [selected]="false">
                    {{option?.descripcion}}
                  </option>
                </select>

                <div class="d-flex flex-row mt-4">
                    <button (click)="limpiarFormEdicion()"
                        class="btn btn-outline-primary border-0 m-auto">Limpiar</button>

                    <button class="btn btn-primary m-auto solicitud-btn-principal" type="submit"
                        [disabled]="!formEdicion.valid">
                        Guardar
                    </button>
                </div>
            </form>

        </div>

        <div class="col-9 p-4 mt-5 mb-5">
            <div class="d-flex justify-content-between mb-4">
                <div>
                    <img src="../../../../../assets/icons/solicitud.png" class="d-inline-block img-responsive mr-3"
                        alt="">
                    <span class="h5">Municipios sin estudio automático</span>
                </div>

                <div>
                    <button type="button" class="btn btn-outline-primary" (click)="isCollapsed = !isCollapsed"
                        [attr.aria-expanded]="!isCollapsed" aria-controls="filtros">
                        Ver filtros
                    </button>
                </div>
            </div>

            <!-- Filtros -->
            <div id="filtros" [ngbCollapse]="isCollapsed" class="mb-4">

                <form [formGroup]="formFiltros" (ngSubmit)="filtrar()">
                    <div class="row">

                        <div class="col-md-3">
                            <label for="fCamaraComercioCtrl" class="small">Cámara de Comercio</label>
                            <select class="form-control form-control-sm" formControlName="fCamaraComercioCtrl">
                                <option value=""></option>
                                <option value="{{item.codigo_camara}}" *ngFor="let item of fCamarasComercio">
                                    {{item.desc_camara}}
                                </option>
                            </select>
                        </div>

                        <div class="col-md-3">
                            <label for="fDepartamentoCtrl" class="small">Departamento</label>
                            <select class="form-control form-control-sm" formControlName="fDepartamentoCtrl">
                                <option value=""></option>
                                <option value="{{item.departamento_id}}" *ngFor="let item of fDepartamentos">
                                    {{item.descripcion}}</option>
                            </select>
                        </div>

                        <div class="col-md-3">
                            <label for="fMunicipioCtrl" class="small">Municipio</label>
                            <select class="form-control form-control-sm" formControlName="fMunicipioCtrl">
                                <option value=""></option>
                                <option value="{{item.municipio_id}}" *ngFor="let item of fMunicipios">
                                    {{item.descripcion}}</option>
                            </select>
                        </div>

                        <div class="col-md-3">
                            <label for="fTipoSolicitudCtrl" class="small">Tipo Solicitud</label>
                            <select class="form-control form-control-sm" formControlName="fTipoSolicitudCtrl">
                                <option value=""></option>
                                <option value="{{item.tipo_solicitud_id}}" *ngFor="let item of fTipoSolicitudes">
                                    {{item.descripcion}}</option>
                            </select>
                        </div>

                        <div class="col-md-3">
                          <label class="small text-secondary" for="categoria">Categoría</label>
                          <select id="fcategoriaCtrl" formControlName="fcategoriaCtrl"  class="form-control form-control-sm" >
                            <option class="" [ngValue]="null" selected="true">
                              Seleccione
                            </option>
                            <option class="" *ngFor="let categoria of categoriafil; let i = index"
                              value="{{categoria?.categoria_id}}" [selected]="false">
                              {{categoria?.descripcion}}
                            </option>
                          </select>
                        </div>

                        <div class="col-md-3">
                            <br>
                            <button (click)="limpiarFormFiltros()" class="btn btn-outline-primary border-0 m-auto">
                                Limpiar
                            </button>

                            <button class="btn btn-primary m-auto solicitud-btn-principal" type="submit">
                                Filtrar
                            </button>
                        </div>
                    </div>
                </form>

            </div>

            <!-- Tabla -->
            <div class="table-responsive">
                <app-tablas class="table-responsive" [page]="paginaActual" [headers]="encabezadosTabla"
                    [sizeData]="dataTable.paging.totalItems" [pageSize]="cantidadPorPagina"
                    (paginado)="onPaginado($event)">
                    <tr *ngFor="let item of dataTable.items; let i=index" class="small">
                        <td>{{item.desc_camara}}</td>
                        <td>{{item.desc_dpto}}</td>
                        <td>{{item.desc_municipio}}</td>
                        <td>{{item.categoria_descripcion}}</td>
                        <td>{{item.tipo_solicitud_descripcion}}</td>
                        <td>
                            <img src="../../../../../../../assets/icons/delete.png" class="pointer" alt="" height="25"
                                (click)="eliminar(item)">
                        </td>
                    </tr>
                </app-tablas>
            </div>

        </div>



    </section>
</main>
